export default __webpack_public_path__ + "static/media/SKIPER.a50fb357.png";